<div class="container">
  <div class="header">
    {{this.message}}
  </div>
  <div class="body">
    <mat-form-field>
      <mat-label>Provide a reason:</mat-label>
      <input matInput [formControl]="reason">
    </mat-form-field>
    <div *ngIf="showToggle">
      <div class="d-flex align-items-center">
        @if (toggleLabels.length > 0) {
          <span>{{toggleLabels[0]}}</span>
        }
        <mat-slide-toggle slot="end" color="primary" (click)="toggleChange()"></mat-slide-toggle>
        @if (toggleLabels.length > 1) {
          <span>{{toggleLabels[1]}}</span>
        }
      </div>
      @if (toggleState) {
        <div>
          <div [innerHtml]="toggleText"></div>
          @if (isToggleInput) {
            <mat-form-field>
              <input matInput [formControl]="toggleInput" numbersOnly>
            </mat-form-field>
          }
        </div>
      }
    </div>
    <div class="buttons">
      <button mat-raised-button (click)="close(false)">Cancel</button>
      <button mat-raised-button (click)="close(true)">Confirm</button>
    </div>
  </div>
</div>